import RecentCallList from "../components/recentCall";

export const CallLogs = () => {
    return (
    <div className=" flex flex-row rows-2">
        <RecentCallList/>
    </div>
    );
}
export default CallLogs;